<div class="prior-appointment-new-wrapper py-5">
    <div class="container">
        <h1 class="fw-600 mb-2">{{ (preReservationLabels() ? 'PREAPPOINTMENT.request' : 'PRIORAPPOINTMENT.request') | translate }}</h1>
        <h3 class="mb-5">{{ (preReservationLabels() ? 'PREAPPOINTMENT.managementSystem' : 'PRIORAPPOINTMENT.managementSystem') | translate }}</h3>
        <div class="steps my-4" *ngIf="!isLoading && community">
            <app-reservation-step1
                    *ngIf="stepNumber == 1"
                    [community]="community"
                    [reservation]="reservation"
                    [preReservationLabels]="preReservationLabels()"
                    [communityModuleId]="communityModuleId"
                    [nextAttempt]="nextAttempt"
                    (formValid)="nextStep()">
            </app-reservation-step1>
            <app-reservation-step2
                    *ngIf="stepNumber == 2"
                    [community]="community"
                    [reservation]="reservation"
                    [preReservationLabels]="preReservationLabels()"
                    [communityModuleId]="communityModuleId"
                    [isPreparingForm]="isPreparingForm"
                    [nextAttempt]="nextAttempt"
                    (priceChanged)="onReservationExtrasChanged()"
                    (formValid)="nextStep()">
            </app-reservation-step2>
            <app-finish-reservation
                    *ngIf="stepNumber == 3"
                    [community]="community"
                    [reservation]="reservation"
                    [preReservationLabels]="preReservationLabels()"
                    [communityModuleId]="communityModuleId"
                    [nextAttempt]="nextAttempt">
            </app-finish-reservation>
        </div>
        <div class="buttons d-flex align-items-center justify-content-between">
            <div>
                <button (click)="prevStep()" class="btn bg-white rounded py-2 px-4 me-4" *ngIf="stepNumber > 1 && stepNumber < 3" [disabled]="isSubmittingPayment || isPreparingForm">
                    <i class="fa fa-arrow-left"></i> {{ (preReservationLabels() ? 'PREAPPOINTMENT.previous' : 'PRIORAPPOINTMENT.previous') | translate }}
                </button>
            </div>
            <div>
                <button (click)="attemptNext()" class="btn bg-white rounded py-2 px-4 me-4 d-inline-flex align-items-center gap-2" *ngIf="stepNumber < 3" [disabled]="isSubmittingPayment || isPreparingForm">
                    @if (isPreparingForm || (isSubmittingPayment && stepNumber === 2)) {
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        <span>{{ (preReservationLabels() ? 'PREAPPOINTMENT.processingAction' : 'PRIORAPPOINTMENT.processingAction') | translate }}</span>
                    } @else if (stepNumber === 2 && requiresPaymentFlow()) {
                        <span>{{ (preReservationLabels() ? 'PREAPPOINTMENT.payReservationAction' : 'PRIORAPPOINTMENT.payReservationAction') | translate }}</span>
                        <span class="fw-600">{{ (reservation?.totalAmount ?? 0) | number:'1.2-2' }} €</span>
                    } @else if (stepNumber === 2) {
                        <span>{{ (preReservationLabels() ? 'PREAPPOINTMENT.completeReservationAction' : 'PRIORAPPOINTMENT.completeReservationAction') | translate }}</span>
                    } @else {
                        <span>{{ (preReservationLabels() ? 'PREAPPOINTMENT.next' : 'PRIORAPPOINTMENT.next') | translate }}</span>
                        <i class="fa fa-arrow-right"></i>
                    }
                </button>
                <button (click)="finishReservation()" class="btn text-white rounded py-2 px-4 fw-500" [style.background-color]=" community?.color1 ? community?.color1 : 'black'" *ngIf="stepNumber === 3">
                    {{(preReservationLabels() ? 'PREAPPOINTMENT.finishReservation' : 'PRIORAPPOINTMENT.finishReservation') | translate }}
                </button>
            </div>
        </div>
    </div>
</div>
